
import { BrowseStateBase } from "@/utils/browse/browse-state-base";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { ViewTotal } from "@/utils/views/view-total";
import { Condition, Operator } from "@/utils/condition/condition";
import Vue from "vue";
import { filterFieldPathToBrowseFieldPath } from "@/utils/models/utils";

export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>BrowseStateBase,
			required: true
		}
	},
	computed: {
		hasSelection(): boolean {
			return this.state.selectedItems.length > 0;
		},
		hasFrontendTotals(): boolean {
			return this.state.querySettings.view.Totals.some((t: ViewTotal) => t.CalculateInFrontend);
		},
		selectionTotals(): FetchedTotal[] {
			if (!this.hasSelection) {
				return [];
			}

			const view = this.state.querySettings.view;
			const selectedItems = this.state.selectedItems;

			// Only calculate frontend totals
			return view.Totals
				.filter((t: ViewTotal) => t.CalculateInFrontend)
				.map((totalConfig: ViewTotal) => {
					return this.calculateTotal(totalConfig, selectedItems);
				});
		}
	},
	methods: {
		calculateTotal(config: ViewTotal, items: any[]): FetchedTotal {
			let total = 0;
			console.log(items, config.Columns);


			// Calculate sum for each column
			config.Columns.forEach((col) => {
				const columnSum = items.reduce((acc, item) => {
					const value = this.getNestedValue(item, col.Column);
					const numValue = parseFloat(value) || 0;
					return acc + numValue;
				}, 0);

				// Apply negative if configured
				total += col.IsNegative ? -columnSum : columnSum;
			});

			// Check conditions for visibility
			const hidden = !this.checkConditions(config.Conditions, total);

			// Format the text
			const lang = (this as any).$i18n.locale || "nl-be";
			const text = this.formatTotalText(config.Label.getTranslation(lang), total);

			return new FetchedTotal({
				Text: text,
				Hidden: hidden,
				Style: config.Style,
			});
		},

		getNestedValue(obj: any, path: string): any {
			const cleanPath = filterFieldPathToBrowseFieldPath(path);
			return cleanPath.split(".").reduce((current, prop) => {
				return current?.[prop];
			}, obj);
		},

		checkConditions(conditions: Condition[], value: number): boolean {
			// If no conditions, always show
			if (!conditions || conditions.length === 0) {
				return true;
			}

			// Simple condition checking using enum
			return conditions.every((condition) => {
				if (condition.Value !== undefined && condition.Value !== "") {
					const compareValue = parseFloat(condition.Value) || 0;
					switch (condition.Operator) {
					case Operator.GT:
						return value > compareValue;
					case Operator.LT:
						return value < compareValue;
					case Operator.GT_OR_EQ:
						return value >= compareValue;
					case Operator.LT_OR_EQ:
						return value <= compareValue;
					case Operator.EQ:
						return value === compareValue;
					case Operator.NEQ:
						return value !== compareValue;
					default:
						return true;
					}
				}
				return true;
			});
		},

		formatTotalText(label: string, value: number): string {
			// Format number with 2 decimals and thousand separators
			const formatted = this.roundDecimals(value, 2, true);
			return label.replace("{value}", formatted);
		},

		roundDecimals(num: number, decimals: number, withSeparator: boolean): string {
			const rounded = num.toFixed(decimals);

			if (!withSeparator) {
				return rounded;
			}

			// Add thousand separator (. for thousands, , for decimals - European format)
			const parts = rounded.split(".");
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
			return parts.join(",");
		}
	}
});
